/* eslint-disable import/no-cycle */
import {
  ACT_DISCONTINUE,
  ACT_NOTIFY,
  ACT_REASSIGN,
} from '../../../components/CertsList/constant';
import { httpService } from '../../../http-service/httpService';
import {
  URL_COLUMN_PICKER_API,
  URL_EXPORT_NEW_API,
  URL_VIEW_API,
} from '../../certdetails/urls';
import {
  getCertListTabsCount,
  setCurrentAction,
  setPageReload,
  setTransitionTileId,
} from '../action';
import {
  axiosTimeoutConfig,
  CERTS_LIST_EXPORT_COLUMNS_TO_EXPORT,
  CERTS_LIST_EXPORT_STATUS,
  CERTS_LIST_RESET_EXPORT_STATUS,
  SET_CERT_LIST_ACTION_DISCONTINUE,
  SET_CERT_LIST_ACTION_ERROR,
  SET_CERT_LIST_ACTION_IS_LOADING,
  SET_CERT_LIST_ACTION_STATUS,
  SET_CERT_LIST_COLUMN_OBJECTS_TO_BE_INCLUDED,
  SET_CERT_LIST_COLUMN_PICKER_ERROR,
  SET_CERT_LIST_COLUMN_PICKER_LIST,
  SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING,
  SET_CERTS_LIST_EMAIL_HISTORY,
} from '../types';
import {
  URL_CANCEL_ACTION_API,
  URL_EMAIL_HISTORY_API,
  URL_NOTIFY_ACTION_API,
  URL_REASSIGN_ACTION_API,
} from '../urls';

export const takeActionDiscontinue = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_ACTION_DISCONTINUE,
    payload,
  });
};

export const setCertsActionIsLoading = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_ACTION_IS_LOADING,
    payload,
  });
};

export const certsActionError = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_ACTION_ERROR,
    payload,
  });
};

export const setCertsListActionStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_ACTION_STATUS,
    payload,
  });
};

export const callDiscontinueAPI = (payload) => async (dispatch) => {
  const { certkey, comments, certificationName } = payload;
  const body = { certkey, comments };

  dispatch(setCertsActionIsLoading(true));

  try {
    const result = await httpService.post(
      URL_CANCEL_ACTION_API,
      body,
      axiosTimeoutConfig
    );

    if (result?.status === 200) {
      dispatch(setCurrentAction(ACT_DISCONTINUE));
      dispatch(setTransitionTileId(certkey));

      dispatch(getCertListTabsCount());

      dispatch(
        setCertsListActionStatus({
          action: ACT_DISCONTINUE,
          status: 'SUCCESS',
          response: `Certification [${certificationName}] has been cancelled.`,
        })
      );

      return { success: true };
    }

    return { success: false };
  } catch (error) {
    dispatch(
      setCertsListActionStatus({
        action: ACT_DISCONTINUE,
        status: 'FAILED',
      })
    );

    return { success: false };
  } finally {
    dispatch(setCertsActionIsLoading(false));
  }
};

export const callReassignAPI = (payload) => async (dispatch) => {
  const { certkey, assignee } = payload;
  const body = { certkey, assignee };

  if (payload?.comments?.length) {
    body.userComments = payload.comments;
  }

  dispatch(setCertsActionIsLoading(true));

  try {
    const { data } = await httpService.post(
      URL_REASSIGN_ACTION_API,
      body,
      axiosTimeoutConfig
    );

    if (data) {
      dispatch(setPageReload(true));

      dispatch(getCertListTabsCount());

      dispatch(
        setCertsListActionStatus({
          action: ACT_REASSIGN,
          status: 'SUCCESS',
          response: data?.response?.replaceAll('<br>', ''),
        })
      );

      return { success: true };
    }

    return { success: false };
  } catch (error) {
    dispatch(
      setCertsListActionStatus({
        action: ACT_REASSIGN,
        status: 'FAILED',
      })
    );

    return { success: false };
  } finally {
    dispatch(setCertsActionIsLoading(false));
  }
};

export const getColumnPickerList = (campaignKey) => async (dispatch) => {
  const body = { campaignKey };

  const { data } = await httpService.post(
    URL_COLUMN_PICKER_API,
    body,
    axiosTimeoutConfig
  );
  const { resultsList } = data;

  dispatch({
    type: SET_CERT_LIST_COLUMN_PICKER_LIST,
    payload: resultsList,
  });
};

export const getCertsViewDetails = (certKey) => async (dispatch) => {
  const body = { certkey: certKey };

  const { data } = await httpService.post(URL_VIEW_API, body);

  const { objectsToBeIncluded } = data;

  dispatch({
    type: SET_CERT_LIST_COLUMN_OBJECTS_TO_BE_INCLUDED,
    payload: { [certKey]: objectsToBeIncluded },
  });
};

export const setCertsListColumnPickerError = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_COLUMN_PICKER_ERROR,
    payload,
  });
};

export const getCertsColumns =
  (certKey, tileCampaignKey) => async (dispatch, getState) => {
    const { columnPickerList, objectsToBeIncluded } =
      getState().certifications.list.lineAction;

    dispatch({
      type: SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING,
      payload: true,
    });

    try {
      const promises = [];

      if (columnPickerList === null) {
        promises.push(dispatch(getColumnPickerList(tileCampaignKey)));
      }

      if (
        objectsToBeIncluded === null ||
        !Object.keys(objectsToBeIncluded).includes(certKey.toString())
      ) {
        promises.push(dispatch(getCertsViewDetails(certKey)));
      }

      if (promises.length > 0) {
        await Promise.all(promises);
      }
    } catch (error) {
      dispatch(setCertsListColumnPickerError(true));
    } finally {
      dispatch({
        type: SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING,
        payload: false,
      });
    }
  };

export const certsListExportColumnsToExport = (payload) => (dispatch) => {
  dispatch({
    type: CERTS_LIST_EXPORT_COLUMNS_TO_EXPORT,
    payload,
  });
};

export const certsListExportStatus = (payload) => (dispatch) => {
  dispatch({
    type: CERTS_LIST_EXPORT_STATUS,
    payload,
  });
};

export const resetCertListExportStatus = () => (dispatch) => {
  dispatch({
    type: CERTS_LIST_RESET_EXPORT_STATUS,
  });
};

export const performCertsListExport =
  (certkey, neoExport, columnsToExport) => async (dispatch) => {
    const body = { certkey, neoExport, callFromCertListExport: true };

    const exportColumns = {};
    // to remove the spaces between column names

    if (columnsToExport && typeof columnsToExport === 'object') {
      Object.keys(columnsToExport).forEach((k) => {
        exportColumns[k.replace(/\s+/g, '')] = columnsToExport[k];
      });
    }

    if (neoExport) {
      body.columnsToExport = exportColumns;
    }

    dispatch(setCertsActionIsLoading(true));

    try {
      const response = await httpService.post(
        URL_EXPORT_NEW_API,
        body,
        // Prevent axios from automatically throwing on 412
        {
          validateStatus: (status) => status === 200 || status === 412,
        }
      );

      if (response?.status === 200) {
        dispatch(
          certsListExportStatus({
            exportStatus: 'SUCCESS',
            timeStamp: Date.now(),
            neoExport,
          })
        );

        return { success: true };
      }

      if (response?.status === 412) {
        dispatch(
          certsListExportStatus({
            exportStatus: 'FAILED-412',
            timeStamp: Date.now(),
            neoExport,
          })
        );

        return { success: true };
      }

      return { success: false };
    } catch (error) {
      dispatch(
        certsListExportStatus({
          exportStatus: 'FAILED',
          timeStamp: Date.now(),
          neoExport,
        })
      );

      return { success: false };
    } finally {
      dispatch(setCertsActionIsLoading(false));
    }
  };

export const setCertsListEmailHistory = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERTS_LIST_EMAIL_HISTORY,
    payload,
  });
};

export const getEmailHistory = (certKey) => async (dispatch) => {
  const body = { certkey: certKey };

  dispatch(setCertsActionIsLoading(true));

  try {
    const { data } = await httpService.post(URL_EMAIL_HISTORY_API, body);

    if (data?.response) {
      dispatch(
        setCertsListEmailHistory({ status: 'SUCCESS', response: data.response })
      );
    }
  } catch (error) {
    dispatch(setCertsListEmailHistory({ status: 'FAILED', response: error }));
  } finally {
    dispatch(setCertsActionIsLoading(false));
  }
};

export const sendNotifyEmail = (certKey) => async (dispatch) => {
  const body = { certkey: certKey, fromCertList: 'yes' };

  dispatch(setCertsActionIsLoading(true));

  try {
    const response = await httpService.post(URL_NOTIFY_ACTION_API, body);

    if (response?.status === 200) {
      dispatch(
        setCertsListActionStatus({
          action: ACT_NOTIFY,
          status: 'INFO',
          response: `${
            response?.data?.response || 'Your notification has been sent'
          }`,
        })
      );

      return { success: true };
    }

    return { success: false };
  } catch (error) {
    dispatch(
      setCertsListActionStatus({
        action: ACT_NOTIFY,
        status: 'FAILED',
        response: error,
      })
    );

    return { success: false };
  } finally {
    dispatch(setCertsActionIsLoading(false));
  }
};
